import { render, staticRenderFns } from "./ProfileSelectionPage.vue?vue&type=template&id=1728d008"
import script from "./ProfileSelectionPage.vue?vue&type=script&lang=js"
export * from "./ProfileSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./ProfileSelectionPage.vue?vue&type=style&index=0&id=1728d008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/user/src/app/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BSpinner, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BSpinner, BCol, BRow})
    

export default component.exports